import { HiShieldCheck } from "react-icons/hi";
import { MdCancel, MdAnalytics } from "react-icons/md";
const data = [
  {
    icon: <HiShieldCheck/>,
    heading: "Optimal Interest Rates",
    detail:
      "Looking to make a smart financial move by securing the best interest rates on the market for your home financing needs? Equilibrium Metro Homes has you covered. We understand the significance of finding the right interest rates to suit your budget and financial goals. In this guide, we'll walk you through how to identify and secure the best interest rates available.",
  },
  {
    icon: <MdCancel />,
    heading: "Price Stability",
    detail:
      "Welcome to Equilibrium Metro Homes, where we prioritize price stability to ensure that everyone has the opportunity to own a comfortable and stylish home without breaking the bank. Our commitment is to provide a harmonious balance between quality, affordability, and customer satisfaction",
  },
  {
    icon: <MdAnalytics />,
    heading: "Market-Leading Price",
    detail:
      "Are you searching for your dream home that perfectly balances comfort, style, and cost? Look no further than Equilibrium Metro Homes, where we bring you top-notch living spaces at market-leading prices! Our mission is to redefine urban living by providing modern, sophisticated homes that are accessible to everyone.",
  },
];
export default data;